import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UtilsService} from "./utils.service";
import {Observable} from "rxjs";
import {HttpHeaders} from "@angular/common/http";
import * as moment from 'moment';
import * as accounting from 'accounting';
import * as _ from 'underscore';


@Injectable()
export class TripService {
  public settings: any;
  public acc: any;
  constructor(
    private httpClient: HttpClient,
    private utils: UtilsService
  ) {
    this.acc = accounting;
  }



  _statusPlan;
  statusPlan(){
    return this._statusPlan;
  };

  /* Methods */

  languages = [];

  // get methods
  is(status) {
    return (this.statusPlan() === status);
  }
  atLeast(status) {
    return (this.statusPlan() >= status);
  };
  lessThan(status) {
    return (this.statusPlan() < status);
  };
  getReadableStatus() {
    let statusText = '';
    let that = this;
    switch (this.statusPlan()) {
      case that.settings.STATUS_PLAN_INIT:
      case that.settings.STATUS_PLAN_STARTED:
      case that.settings.STATUS_PLAN_COUNTRIES:
        statusText = 'Set Dates of Travel';
        break;
      case this.settings.STATUS_PLAN_DATES:
        statusText = 'Traveler Information';
        break;
      case this.settings.STATUS_PLAN_TRAVELERS:
        statusText = 'Specify Traveling Children';
        break;
      case this.settings.STATUS_PLAN_CHILDREN:
        statusText = 'Specify Traveling Students';
        break;
      case this.settings.STATUS_PLAN_STUDENTS:
        statusText = 'Configure Accommodations';
        break;
      case this.settings.STATUS_PLAN_HOTEL_ROOMS:
        // 	return 'Select Languages';
        // 	break;
        // case Trip.STATUS_PLAN_LANGUAGE:
        statusText = 'Build Wish List';
        break;
      case this.settings.STATUS_PLAN_AGENCY:
        statusText = 'Confirm Pricing';
        break;
      case this.settings.STATUS_PLAN_SUBMITTED:
        statusText = 'Submitted to MyBhutan';
        break;
      default:
        statusText = '';
        break;
    }
    return statusText;
  };
  getLanguages() {

    if (this.atLeast(this.settings.STATUS_PLAN_LANGUAGE)) {
      return [
        'English'
      ];
    } else {
      return [];
    }

  };
  getStartDate = function (startDate) {
    if (!startDate) {
      return '';
    }

    let date = moment(startDate);
    return (date.isValid()) ? date.format('MM/DD/YYYY') : '';
};
  getEndDate = function (endDate) {
    if (!endDate) {
      return '';
    }

    let date = moment(endDate);
    return (date.isValid()) ? date.format('MM/DD/YYYY') : '';
  };
  getNumberOfNights = function (startDate, endDate) {
    if (!startDate || !endDate) {
      return 0;
    }

    let sd = moment(startDate),
      ed = moment(endDate);

    return ed.diff(sd, 'days');
  };
  getDashboardSubtitle = function (startDate) {
    if (!startDate) {
      return 'Future';
    }
    let sd = moment(startDate);
    return (sd.isValid()) ? sd.format('MMMM YYYY') : 'Future';
  };
  getNumberOfTravelers = function (numberOfTravelers) {
    let travelers = parseInt(numberOfTravelers, 10);
    return (_.isNaN(travelers)) ? null : travelers;
  };
  getNumberOfYoungChildren = function (numberOfYoungChildren) {
    let youngChildren = parseInt(numberOfYoungChildren, 10);
    return (_.isNaN(youngChildren)) ? null : youngChildren;
  };
  getNumberOfChildren = function (numberOfChildren) {
    let children = parseInt(numberOfChildren, 10);
    return (_.isNaN(children)) ? null : children;
  };
  getNumberOfStudents = function (numberOfStudents) {
    let students = parseInt(numberOfStudents, 10);
    return (_.isNaN(students)) ? null : students;
  };
  getNumberOfHotelRooms = function (numberOfTravelers, numberOfHotelRooms) {
    if (numberOfHotelRooms) {
      return numberOfHotelRooms;
    }

    if (numberOfTravelers) {
      return '';
    }

    return Math.round(numberOfTravelers / 2);
  };
  getNumberOfExtraHotelRooms = function (numberOfTravelers, numberOfHotelRooms) {
    if (!numberOfTravelers) {
      return 0;
    }
    return _.max([0, (numberOfHotelRooms - Math.round(numberOfTravelers / 2))]);
  };
  getNumberOfFewerHotelRooms = function (numberOfTravelers, numberOfHotelRooms) {
    return _.max([0, (Math.round(numberOfTravelers / 2) - numberOfHotelRooms)]);
  };
  getNightRange = function (sd, ed) {

    let startDate = moment(sd),
      endDate = moment(ed).subtract(1, 'days'),
      iterator = startDate.clone(),
      days = [];

    if (!startDate.isValid() || !endDate.isValid()) {
      return 0;
    }

    while (!moment(iterator).isAfter(endDate)) {
      days.push(iterator.clone());
      iterator.add(1, 'd');
    }
    return days;
  };
  getNumberOfPeakNights = function (startDate, endDate) {
    let days = 0;
    if(!startDate || !endDate){
      return days;
    }
    let that = this;
    let nightRange = this.getNightRange(startDate, endDate);
    for(let i=0;i<nightRange.length;i++){
      let mn = nightRange[i].month() + 1;
      if(that.settings.PEAK_MONTHS.indexOf(mn)>-1){
        days++;
      }
    }
    return days;
  };
  getNumberOfOffPeakNights = function (startDate, endDate) {
    let days = 0;
    let that = this;
    let nightRange = this.getNightRange(startDate, endDate);
    for(let i=0;i<nightRange.length;i++){
      let mn = nightRange[i].month() + 1;
      if(that.settings.PEAK_MONTHS.indexOf(mn)===-1){
        days++;
      }
    }
    return days;
  };
  getAverageCostPerNight = function (startDate, endDate) {
    return (this.calculatePeakNightsCost(startDate, endDate) + this.calculateOffPeakNightsCost(startDate, endDate)) / this.getNumberOfNights(startDate, endDate);
  };
  getNumberOfHalfDiscountedNights = function (startDate, endDate) {
    let nights = this.getNumberOfNights(startDate, endDate);

    if (nights > 14) {
      return 6;
    }

    return _.max([0, nights - 8]);
  };
  getNumberOfFullDiscountedNights = function (startDate, endDate) {
    let nights = this.getNumberOfNights(startDate, endDate);

    if (nights <= 14) {
      return 0;
    }

    return _.max([0, nights - 14]);
  };

  // set methods

  setStartDate = function (date) {
    let dt = moment(date);

    // set date through API?

    /*if (!dt.isValid()) {
     this.startDate(null);
     }

     this.startDate(date.format());*/
  };
  setEndDate = function (date) {
    let dt = moment(date);

    // set date through API?
    /*if (!dt.isValid()) {
     this.endDate(null);
     }
     this.endDate(date.format());*/
  };
  setNumberOfChildren = function (children) {
    children = parseInt(children, 10);

    // set number of children through API

    /*if (_.isNaN(children)) {
     return this.numberOfChildren(0);
     }

     this.numberOfChildren(children);*/
  };
  setNumberOfYoungChildren = function (children) {
    children = parseInt(children, 10);


    // set number of young children through API

    /*if (_.isNaN(children)) {
     return this.numberOfYoungChildren(0);
     }

     this.numberOfYoungChildren(children);*/
  };
  setNumberOfStudents = function (students) {
    students = parseInt(students, 10);

    // set number of students through API

    /*if (_.isNaN(students)) {
     return this.numberOfStudents(null);
     }

     this.numberOfStudents(students);*/
  };
  reset = function () {
    return {
      statusPlan: this.settings.STATUS_PLAN_INIT,
      startDate: null,
      endDate: null,
      numberOfTravelers: null,
      numberOfChildren: null,
      numberOfYoungChildren: null,
      numberOfStudents: null,
      numberOfHotelRooms: null,
      agencyId: null,
      languages: []
    };
  };


  // math methods
  calculatePeakNightsCost = function (startDate, endDate) {
    let that = this;
    if (!startDate || !endDate) {
      return 0;
    }
    let numberOfPeakNights = that.getNumberOfPeakNights(startDate, endDate);

    return (numberOfPeakNights * that.settings.COST_PEAK);
  };
  calculateOffPeakNightsCost = function (startDate, endDate) {
    let that = this;
    if (!startDate || !endDate) {
      return 0;
    }
    let numberOfOffPeakNights = that.getNumberOfOffPeakNights(startDate, endDate);
    return (numberOfOffPeakNights * that.settings.COST_OFF_PEAK);
  };
  calculatePeakSavings = function (numberOfPeakNights) {
    let that = this;
    return (numberOfPeakNights * that.settings.SAVINGS_PEAK);
  };
  calculateOffPeakSavings = function (numberOfOffPeakNights) {
    let that = this;
    return (numberOfOffPeakNights * that.settings.SAVINGS_OFF_PEAK);
  };
  calculateTotalSavings = function (startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents) {
    let numberOfPeakNights = this.getNumberOfPeakNights(startDate, endDate);
    let numberOfOffPeakNights = this.getNumberOfOffPeakNights(startDate, endDate);
    return this.calculatePeakSavings(numberOfPeakNights) + this.calculateOffPeakSavings(numberOfOffPeakNights) - this.calculateProcessingFee(startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents);
  };
  calculateSingleSurcharge = function (numberOfTravelers, numberOfNights) {
    let that = this;
    if (numberOfTravelers !== 1) {
      return 0;
    }
    return that.settings.SURCHARGE_SINGLE * numberOfNights;
  };
  calculateDoubleSurcharge = function (numberOfTravelers, numberOfNights) {
    let that = this;
    if (that.getNumberOfTravelers(numberOfTravelers) !== 2) {
      return 0;
    }

    return that.settings.SURCHARGE_DOUBLE * numberOfTravelers * numberOfNights;
  };
  calculateExtraHotelRoomSurcharge = function (numberOfTravelers, numberOfHotelRooms, numberOfNights) {
    let that = this;
    let exh = that.getNumberOfExtraHotelRooms(numberOfTravelers, numberOfHotelRooms) * that.settings.COST_EXTRA_ROOM * numberOfNights;
    if(!isNaN(exh)) return exh;
  };
  calculateVisaSubtotal = function (numberOfTravelers) {
    let that = this;
    return numberOfTravelers * that.settings.COST_TRAVEL_VISA;
  };
  calculateYoungChildDiscount = function (startDate, endDate, numberOfNights, numberOfYoungChildren) {
    return this.getAverageCostPerNight(startDate, endDate) * numberOfNights * numberOfYoungChildren;
  };
  calculateChildDiscount = function (startDate, endDate, numberOfChildren) {
    /* check */
    return this.getAverageCostPerNight(startDate, endDate) * this.getNumberOfNights(startDate, endDate) * numberOfChildren * 0.5;
  };
  calculateStudentDiscount = function (startDate, endDate, numberOfNights, numberOfStudents) {
    return this.getAverageCostPerNight(startDate, endDate) * numberOfNights * numberOfStudents * 0.25;
  };
  calculateTotalGroupDiscount = function (startDate, endDate, numberOfTravelers) {

    let that = this;
    let discount = 0;

    if (!this.qualifiesForGroupDiscount(numberOfTravelers)) {
      return 0;
    }

    if (this.qualifiesForHalfGroupDiscount(numberOfTravelers)) {
      discount = 0.5;
    }

    if (this.qualifiesForFullGroupDiscount(numberOfTravelers)) {
      discount = 1;
    }

    let nr = that.getNightRange(startDate, endDate);
    let total = 0;
    for(let i=0;i<nr.length;i++){
      let mn = nr[i].month();
      if(that.settings.PEAK_MONTHS.indexOf(mn)>-1){
        total += that.settings.COST_PEAK;
      }else{
        total += that.settings.COST_OFF_PEAK;
      }
    }
    return total * discount;
  };
  calculateHalfDurationDiscount = function (startDate, endDate, numberOfTravelers) {
    let nights = this.getNumberOfHalfDiscountedNights(startDate, endDate);
    return nights * 32.50 * numberOfTravelers;
  };
  calculateFullDurationDiscount = function (startDate, endDate, numberOfTravelers) {
    let nights = this.getNumberOfFullDiscountedNights(startDate, endDate);
    return nights * 65 * numberOfTravelers;
  };
  calculateTotalDurationDiscount = function (startDate, endDate, numberOfTravelers) {
    return this.calculateHalfDurationDiscount(startDate, endDate, numberOfTravelers) + this.calculateFullDurationDiscount(startDate, endDate, numberOfTravelers);
  };
  calculateFewerHotelRoomDiscount = function (startDate, endDate, numberOfTravelers, numberOfHotelRooms) {
    return this.getNumberOfFewerHotelRooms(numberOfTravelers, numberOfHotelRooms) * 40 * this.getNumberOfNights(startDate, endDate);
  };
  calculateBaselineSubtotal = function (startDate, endDate, numberOfTravelers) {
    let subt = this.getAverageCostPerNight(startDate, endDate) * this.getNumberOfNights(startDate, endDate) * numberOfTravelers;
    if(!isNaN(subt)){
      return subt;
    }
  };
  calculateCombinedSurcharges = function (numberOfTravelers, numberOfHotelRooms, numberOfNights) {
    return this.calculateSingleSurcharge(numberOfTravelers, numberOfNights)
      + this.calculateDoubleSurcharge(numberOfTravelers, numberOfNights)
      + this.calculateExtraHotelRoomSurcharge(numberOfTravelers, numberOfHotelRooms, numberOfNights);
  };
  calculateCombinedDiscounts = function (startDate, endDate, numberOfChildren, numberOfNights, numberOfYoungChildren, numberOfStudents, numberOfTravelers, numberOfHotelRooms) {

    return this.calculateChildDiscount(startDate, endDate, numberOfChildren)
      + this.calculateYoungChildDiscount(startDate, endDate, numberOfNights, numberOfYoungChildren)
      + this.calculateStudentDiscount(startDate, endDate, numberOfNights, numberOfStudents)
      + this.calculateTotalGroupDiscount(startDate, endDate, numberOfTravelers)
      + this.calculateFewerHotelRoomDiscount(startDate, endDate, numberOfTravelers, numberOfHotelRooms)
      + this.calculateTotalDurationDiscount(startDate, endDate, numberOfTravelers);
  };
  calculateSubtotal = function (startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents) {
    return this.calculateBaselineSubtotal(startDate, endDate, numberOfTravelers)
      + this.calculateVisaSubtotal(numberOfTravelers)
      + this.calculateCombinedSurcharges(numberOfTravelers, numberOfHotelRooms, numberOfNights)
      - this.calculateCombinedDiscounts(startDate, endDate, numberOfChildren, numberOfNights, numberOfYoungChildren, numberOfStudents, numberOfTravelers, numberOfHotelRooms)
  };
  calculateProcessingFee = function (startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents) {
    return (this.calculateSubtotal(startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents) * 0.035) + 40;
  };
  calculateTotal = function (startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents) {
    return this.calculateSubtotal(startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents)
      + this.calculateProcessingFee(startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents);
  };
  buildSavingsTooltip = function (startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfChildren, numberOfYoungChildren, numberOfStudents) {

    let tooltip = '';

    let numberOfNights = this.getNumberOfNights(startDate, endDate);
    let numberOfPeakNights = this.getNumberOfPeakNights(startDate, endDate);
    let numberOfOffPeakNights = this.getNumberOfOffPeakNights(startDate, endDate);

    if (numberOfPeakNights) {
      tooltip += numberOfPeakNights + ' nights (peak)';
    }

    if (numberOfOffPeakNights) {

      if (numberOfPeakNights) {
        tooltip += ' and ';
      }

      tooltip += numberOfOffPeakNights + ' nights (off-peak)';
    }

    tooltip += ' would normally cost about ';

    //noinspection TypeScriptUnresolvedFunction
    tooltip += accounting.formatMoney(this.calculateSubtotal(startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents) + this.calculateTotalSavings(startDate, endDate, numberOfTravelers, numberOfHotelRooms, numberOfNights, numberOfChildren, numberOfYoungChildren, numberOfStudents));

    return tooltip;

  };


  // boolean methods
  qualifiesForYoungChildDiscount = function (numberOfYoungChildren) {
    return !!(parseInt(numberOfYoungChildren, 10));
  };
  qualifiesForChildDiscount = function (numberOfChildren) {
    return !!(parseInt(numberOfChildren, 10));
  };
  qualifiesForStudentDiscount = function (numberOfStudents) {
    return (parseInt(numberOfStudents, 10) > 0);
  };
  qualifiesForGroupDiscount = function (numberOfTravelers) {
    return (this.qualifiesForHalfGroupDiscount(numberOfTravelers) || this.qualifiesForFullGroupDiscount(numberOfTravelers));
  };
  qualifiesForHalfGroupDiscount = function (numberOfTravelers) {
    return (numberOfTravelers >= 11 && numberOfTravelers <= 15);
  };
  qualifiesForFullGroupDiscount = function (numberOfTravelers) {
    return (parseInt(numberOfTravelers, 10) >= 16);
  };
  qualifiesForDurationDiscount = function (numberOfNights) {
    return (parseInt(numberOfNights, 10) >= 9);
  };
  qualifiesForHalfDurationDiscount = function (numberOfNights) {
    return (parseInt(numberOfNights, 10) >= 9);
  };
  qualifiesForFullDurationDiscount = function (startDate, endDate) {
    return !!(parseInt(this.getNumberOfNights(startDate, endDate), 10) >= 14);
  };

  getOne(tripId): Observable<any> {

    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.get(this.utils.apiEndpoint+'trip/'+tripId+'/', {
      responseType: 'json',
      headers: httpHeaders
    });

  }

  saveOne(trip): Observable<any> {

    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.utils.apiEndpoint+'trip/'+trip.instance.id, trip, {
      responseType: 'json',
      headers: httpHeaders
    });

  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/trip.service.ts